import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quiensomos',
  templateUrl: './quiensomos.component.html',
  styleUrls: ['./quiensomos.component.scss']
})
export class QuiensomosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
